import React from 'react';
import ListOrganizationFile from './listOrganizationFile';

// La liste porte sa propre fiche : cet enrobage n'ajoutait qu'une grille.
function OrganizationFiles() {
  return <ListOrganizationFile />;
}

export default OrganizationFiles;
